import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export default function AddressDetails(props) {
  const { Flist, Tlist } = props;

  return (
    <Row>
      <Col md={6}>
        <Row
          style={{
            backgroundColor: "var(--color-brand)",
            textAlign: "center",
            color: "var(--color-ui-surface)",
          }}
        >
          <b className="modal__shipment_confirmation_sec_title"> Ship From </b>
        </Row>
        <Row className="my-1">
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>Name:</b>
            </small>
          </Col>
          <Col md={8}>
            <small className="modal__shipment_confirmation_list_detail">
              {Flist["attention"]}
            </small>
          </Col>
        </Row>
        <Row className="my-1">
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>Company:</b>
            </small>
          </Col>
          <Col md={8}>
            <small className="modal__shipment_confirmation_list_detail">
              {Flist["company"]}
            </small>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>Address:</b>
            </small>
          </Col>
          <Col md={8} style={{ whiteSpace: "pre-line" }}>
            <small className="modal__shipment_confirmation_list_detail">
              {Flist["address"]}
            </small>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>Country:</b>
            </small>
          </Col>
          <Col md={8} style={{ whiteSpace: "pre-line" }}>
            <small className="modal__shipment_confirmation_list_detail">
              {Flist["country"]}
            </small>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>State:</b>
            </small>
          </Col>
          <Col md={8} style={{ whiteSpace: "pre-line" }}>
            <small className="modal__shipment_confirmation_list_detail">
              {Flist["state"]}
            </small>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>City:</b>
            </small>
          </Col>
          <Col md={8} style={{ whiteSpace: "pre-line" }}>
            <small className="modal__shipment_confirmation_list_detail">
              {Flist["city"]}
            </small>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>Zip/Postal:</b>
            </small>
          </Col>
          <Col md={8} style={{ whiteSpace: "pre-line" }}>
            <small className="modal__shipment_confirmation_list_detail">
              {Flist["zip"]}
            </small>
          </Col>
        </Row>

        <Row className="my-1">
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>Phone:</b>
            </small>
          </Col>
          <Col md={8}>
            <small className="modal__shipment_confirmation_list_detail">
              {Flist["phone"]}
            </small>
          </Col>
        </Row>
        <Row className="my-1">
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>Email:</b>
            </small>
          </Col>
          <Col md={8}>
            <small className="modal__shipment_confirmation_list_detail">
              {Flist["email"]}
            </small>
          </Col>
        </Row>
      </Col>

      <Col md={6}>
        <Row
          style={{
            backgroundColor: "var(--color-brand)",
            textAlign: "center",
            color: "var(--color-ui-surface)",
          }}
        >
          <b className="modal__shipment_confirmation_sec_title"> Ship To </b>
        </Row>
        <Row className="my-1">
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>Name:</b>
            </small>
          </Col>
          <Col md={8}>
            <small className="modal__shipment_confirmation_list_detail">
              {Tlist["attention"]}
            </small>
          </Col>
        </Row>
        <Row className="my-1">
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>Company:</b>
            </small>
          </Col>
          <Col md={8}>
            <small className="modal__shipment_confirmation_list_detail">
              {Tlist["company"]}
            </small>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>Address:</b>
            </small>
          </Col>
          <Col md={8} style={{ whiteSpace: "pre-line" }}>
            <small className="modal__shipment_confirmation_list_detail">
              {Tlist["address"]}
            </small>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>Country:</b>
            </small>
          </Col>
          <Col md={8} style={{ whiteSpace: "pre-line" }}>
            <small className="modal__shipment_confirmation_list_detail">
              {Tlist["country"]}
            </small>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>State:</b>
            </small>
          </Col>
          <Col md={8} style={{ whiteSpace: "pre-line" }}>
            <small className="modal__shipment_confirmation_list_detail">
              {Tlist["state"]}
            </small>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>City:</b>
            </small>
          </Col>
          <Col md={8} style={{ whiteSpace: "pre-line" }}>
            <small className="modal__shipment_confirmation_list_detail">
              {Tlist["city"]}
            </small>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>Zip/Postal:</b>
            </small>
          </Col>
          <Col md={8} style={{ whiteSpace: "pre-line" }}>
            <small className="modal__shipment_confirmation_list_detail">
              {Tlist["zip"]}
            </small>
          </Col>
        </Row>

        <Row className="my-1">
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>Phone:</b>
            </small>
          </Col>
          <Col md={8}>
            <small className="modal__shipment_confirmation_list_detail">
              {Tlist["phone"]}
            </small>
          </Col>
        </Row>
        <Row className="my-1 mb-1">
          <Col md={4}>
            <small className="modal__shipment_confirmation_list_title">
              <b>Email:</b>
            </small>
          </Col>
          <Col md={8}>
            <small className="modal__shipment_confirmation_list_detail">
              {Tlist["email"]}
            </small>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}
